export default [
  {
    id: 1,
    title: '机器视觉',
    image: require('@/assets/img/coreTechnology/tech_1.png'),
    date: '2024-01-01 06:05:08',
    content: [
      '以AI+3D为核心，搭建新一代机器视觉智能编程环境，可视化、无代码的编程界面，一键仿真，实现产品标准化、全场景应用。视觉算法具有精度高、视野大，优异的抗环境光性能。',
      ''
    ],
    category: '机器视觉',
    display: true,
  },
  {
    id: 2,
    title: '基于人脸识别的动态检测识别技术',
    image: require('@/assets/img/coreTechnology/tech_2.jpg'),
    date: '2024-01-02 00:50:51',
    content: [
      '基于人脸识别的轨迹检测跟踪技术采用区域特征分析算法，融合了计算机图像处理技术与生物统计学原理于一体，利用计算机图像处理技术从视频中提取人像特征点，利hai用生物统计学的原理进行分析建立数学模型，具有广阔的发展前景。',
      '基于人脸识别的轨迹检测跟踪系统通过各人脸识别摄像机与服务器协同合作进行人员的实时跟踪，为管理人员提供了人员的实时位置信息，同时为查阅人员行走轨迹和视频提供了支持，便于管理人员管理监管区域。'
    ],
    category: '基于人脸识别的动态检测识别技术'
  },
  {
    id: 3,
    title: '人脸搜索',
    image: require('@/assets/img/coreTechnology/tech_3.jpg'),
    date: '2024-01-03 04:10:56',
    content: [
      '给定一张照片，对比人脸库中N张人脸，进行1：N、M：N检索，找出最相似的一张或多张人脸，并返回相似度分数。',
      '支持百万级人脸库管理。'
    ],
    category: '人脸搜索',
    display: true,
  },
  {
    id: 4,
    title: '视线跟踪技术（疲劳状态检测）',
    image: require('@/assets/img/coreTechnology/tech_4.jpg'),
    date: '2024-01-04 07:31:52',
    content: [
      '视线跟踪技术有助于确定人在数字屏幕上的注视位置，反馈眨眼频率以及瞳孔对不同刺激的反应。因此，它有助于确定一个人的视线方向，是否困倦，判断他的焦点等。该技术在智能手机、AR/VR游戏、智能汽车等领域的人机交互有着广泛的应用前景。',
      '瑞谦的视线跟踪技术能够准确检测人眼视线运动，操作简单自然，能够在用户无感知的条件下进行交互，操作交互速度可实时与用户观看速度进行同步。',
      '目前，该技术已应用到驾驶人员疲劳状态检测系统中，通过实时模拟驾驶员的视野，根据驾驶员视线判断盲区，及时提醒可能存在的危险；当驾驶员眼皮下垂(犯困)或眨眼次数减少(走神)等，给出及时提醒。',
      ''
    ],
    category: '视线跟踪技术（疲劳状态检测）',
    display: true,
  },
  {
    id: 5,
    title: 'NB-IOT 物联网通讯技术',
    image: require('@/assets/img/coreTechnology/tech_5.jpg'),
    date: '2024-01-05 17:27:09',
    content: [
      'NB-IOT是窄带物联网的关键技术，显著特征如下：强链接：同一基站，NB-IoT比现有无线技术提供50-100倍的接入数。',
      '一个扇区能够支持10万个连接。'
    ],
    category: 'NB-IOT 物联网通讯技术',
    display: true,
  },
  {
    id: 6,
    title: 'NNIE卷积神经网络引擎加速',
    image: require('@/assets/img/coreTechnology/tech_6.png'),
    date: '2024-01-06 07:03:29',
    content: [
      '某品牌 SoC 中专门针对神经网络特别是深度学习卷积神经网络进行加速处理的硬件单元，人脸识别算法的处理速度在设备层面达到毫秒级运算。',
      '带有NNIE加速引擎NPU单元的SoC芯片让人工智能算法的运算速度成倍地增加，设备功耗成倍地降低，真正的智能终端产品成为现实。'
    ] ,
    category: 'NNIE卷积神经网络引擎加速',
    display: true,
  },
  {
    id: 7,
    title: 'ISP图像处理算法技术',
    image: require('@/assets/img/coreTechnology/tech_7.jpg'),
    date: '2024-01-07 09:21:26',
    content: [
      '运用多模式HDR融合技术、联合色调映射HDR压缩技术、高级自动追踪白平衡算法、自适应快速稳定AEC算法、自适应导向CFA插值算法、色彩校正、细节增强、智能降噪、多光谱融合算法、镜头畸变矫正等多种图像信号处理算法，结合不同的SENSOR和镜头，支持算法和识别设备获取到支持“全场景”工作的优质图像，彻底滤除强光、背光、弱光以及其他各种环境恶劣光线条件的干扰。'
    ],
    category: 'ISP图像处理算法技术',
    display: true,
  },
  {
    id: 8,
    title: '深度学习人脸属性分析技术',
    image: require('@/assets/img/coreTechnology/tech_8.png'),
    date: '2024-01-08 17:43:50',
    content: [
      '运用深度学习技术，构建多层机器学习模型进行人脸属性和人脸照片样本的数据训练，准确判断照片中人物的各项人脸属性，包括年龄、性别、种族、表情（微笑/颜值）、胡子、遮挡、戴眼镜和戴墨镜等属性。'
    ],
    category: '深度学习人脸属性分析技术',
    display: true,
  },
  {
    id: 9,
    title: '深度学习动态人脸识别技术',
    image: require('@/assets/img/coreTechnology/tech_9.png'),
    date: '2024-01-09 06:54:07',
    content: [
      '运用深度学习技术，构建多层机器学习模型和超过一亿的海量人脸照片样本，进行数据训练。',
      '样本数据包含证件大照片和小照片和各种场景照片，所以算法可以适用于各种照片模板；算法识别率高：万分之一错误率情况下，识别率超过99%；十万分之一错误率情况下，识别率超过97%。'
    ],
    category: '深度学习动态人脸识别技术',
    display: true,
  },
  {
    id: 10,
    title: '人脸验证算法',
    image: require('@/assets/img/coreTechnology/tech_10.jpg'),
    date: '2024-01-10 18:27:49',
    content: [
      '通过各种器具读取/扫描的证件照片（居民身份证、港澳台居住证、护照、驾照等）与摄像机抓取的实时图像中抓取的人脸照片进行实时比对，确认证件持有人为本人。',
      '算法可以支持Windows、Android、Linux、中科麒麟等各种不同的系统主机操作系统。'
    ],
    category: '人脸验证算法',
    display: true,
  },
  {
    id: 11,
    title: '人脸活体检测算法',
    image: require('@/assets/img/coreTechnology/tech_11.jpg'),
    date: '2024-01-11 10:29:47',
    content: [
      '基于彩色和红外双目摄像机的两帧图像，基于活体和非活体的成像差异，运用深度学习海量样本库训练而成的活体检测算法，实时检测各种照片、视频和玩偶等非活体攻击对象，完美实现人脸活体的精确识别，检测准确率超过99.5%。'
    ],
    category: '人脸活体检测算法',
    display: true,
  },
  {
    id: 12,
    title: '头部姿态人脸检测',
    image: require('@/assets/img/coreTechnology/tech_12.jpg'),
    date: '2024-01-12 08:16:20',
    content: [
      '通过深度学习海量样本训练的“头肩”检测算法，精准检测和跟踪视频图像中的“头肩”目标，实现人数统计，准确率可以达到95%以上。',
      '算法运行于海思SoC芯片的NPU单元，算法运算速度成倍地增加，可以支持快速运动中的人体目标的检测和遮挡不超过70%的目标识别，确保人数统计的精准度。',
      '此技术可以广泛应用于商业场所的客流统计、集会场所的非法聚集检测。'
    ],
    category: '头部姿态人脸检测',
    display: true,
  },
  {
    id: 13,
    title: '人体姿态检测',
    image: require('@/assets/img/coreTechnology/tech_13.jpg'),
    date: '2024-01-13 07:05:38',
    content: [
      '通过深度学习海量样本训练，精准定位人体的18个主要 关键节点，对视频中人体的行为姿态进行精准识别，可以对自定义的危 险行为动作进行实时预警，比如：打架、斗殴、抢劫、蒙头、聚众、爬 床、自残、摔倒等。'
    ],
    category: '人体姿态检测',
    display: true,
  }
]
